import React from 'react';
import PropTypes from 'prop-types';

const TravelRewards = ({ className }) => (
  <svg
    className={className}
    fill="none"
    viewBox="0 0 114 114"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity=".2"
      d="M57 114c31.48 0 57-25.52 57-57S88.48 0 57 0 0 25.52 0 57s25.52 57 57 57z"
      fill="#B1E0E2"
    />
    <path
      d="M38.226 60.565L27.182 57.43l-4.809 3.562 13.039 10.26L42.038 86.5l4.774-3.563V70.326c3.954-3.064 6.483-4.952 14.25-11.008l8.407 23.441 6.413-4.916-1.995-28.5 13.965-10.688c1.318-1.033 5.237-7.303 3.1-10.046-2.138-2.743-9.05-.57-10.439.463-1.39 1.033-4.382 3.313-10.688 8.087"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M66.547 39.9l3.384-2.6c6.235-4.774 9.726-7.446 10.688-8.087.962-.642 8.336-3.242 10.438-.463 2.102 2.778-1.781 9.013-3.1 10.046L73.993 49.483M42.395 58.07c1.104-.856 9.974-7.304 11.364-8.373M61.097 59.318c-7.908 6.056-10.438 7.945-14.25 11.008v12.612L42.074 86.5l-6.662-15.247-13.039-10.367 4.81-3.563M73.923 49.485l1.995 28.394-6.413 4.88-8.407-23.441M53.758 49.696L33.273 35.482l6.413-4.917L66.547 39.9"
      stroke="#2061AE"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

TravelRewards.defaultProps = {
  className: '',
};

TravelRewards.propTypes = {
  className: PropTypes.string,
};

export default TravelRewards;
